export const Input = {
  baseStyle: {
    field: {
      _placeholder: {
        color: 'gray.400',
      },
      borderColor: 'border',
      borderWidth: '1px',
      borderRadius: '8px',
      '&:hover': {
        borderColor: 'borderHover',
      },
      '&:focus': {
        borderColor: 'primary',
      },
    },
  },
  sizes: {
    sm: {
      field: {
        fontSize: '12px',
        padding: '16px',
      },
    },
    md: {
      field: {
        fontSize: '16px',
        paddingTop: '21px',
        paddingBottom: '21px',
        paddingLeft: '16px',
        height: '62px',
      },
    },
  },
  variants: {
    outline: {
      field: {
        backgroundColor: 'background',
        // "&:hover": {
        //   borderColor: 'borderHover',
        // },
        // borderRadius: '8px',
        // '&:focus': {
        //   borderColor: 'primary',
        //   boxShadow: '0px 10px 12px -3px rgba(0, 0, 0, 0.02), 0px 4px 2px -2px rgba(0, 0, 0, 0.02)',
        // },
        _invalid: {
          boxShadow: '0px 10px 12px -3px rgba(0, 0, 0, 0.02), 0px 4px 2px -2px rgba(0, 0, 0, 0.02)',
        },
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
}
